import React from 'react';
import { calculatePercentage } from '../../helpers/common';
import styled from 'styled-components';
const ProgressStyles = styled.div`
  background: ${({ $bg }) => $bg ?? '#262626'};
  height: 8px;
  border-radius: 10px;
  width: 100%;
  position: relative;
  overflow: hidden;
  margin-bottom: 6px;
  &::before {
    position: absolute;
    content: '';
    top: 0;
    bottom: 0;
    left: 0;
    width: ${({ $width }) => $width};
    background: ${({ $color }) => $color ?? '#2783ec'};
    border-radius: 15px;
  }
`;
const ProgressBar = ({ usedCr, totalCr, color, bg }) => {
  return <ProgressStyles $color={color} $bg={bg} $width={calculatePercentage(usedCr, totalCr)} />;
};

export default ProgressBar;
